import UAParser from 'ua-parser-js';

export function isMobile() {
  if (typeof navigator === 'undefined') return false;
  const agent = navigator.userAgent.toLowerCase();
  const parser = new UAParser();
  const { name, version } = parser.getOS();
  const { model } = parser.getDevice();

  if (model === 'iPad' && name === 'iOS' && version && parseInt(version, 2) >= 13) return false;

  return Boolean(/(iphone|ipad|ipod|android|windows phone)/.test(agent));
}
